import { useState } from 'react';

const useIsAndroidOrIOS = () => {
  const [isIOS] = useState(
    () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
      (navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 0)
  );
  const [isAndroid] = useState(() => /android/i.test(navigator.userAgent || ''));

  return { isIOS, isAndroid };
};

export { useIsAndroidOrIOS };
